import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { HotlineClientDetailMeetingPage } from '@/feature/hotline/client/detail/meeting/page/HotlineClientDetailMeetingPage';
import { hotlineClientAuthOptions } from '@/feature/hotline/client/util/canUseHotlineUser';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
/**
 * 匿名コンサルホットライン 面談実施
 */
export const HotlineClientDetailMeeting = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, redirectTo: authRedirectTo } = useAuthentication(hotlineClientAuthOptions);
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return _jsx(HotlineClientDetailMeetingPage, {});
};
